import camelCase from 'lodash.camelcase';
import * as React from 'react';

import i18n from 'helper/i18n';

import Cta from 'components/atoms/Cta';
import CardPreview from 'components/molecules/CardPreview';
import { CardPreviewProps } from 'components/molecules/CardPreview';

export type ProgramViewProps = {
	onStartProgram: (event: React.MouseEvent<HTMLAnchorElement>) => void;
	preview?: string;
	previewItems: any[];
	inactive?: boolean;
	params?: {
		[key: string]: any;
	};
};

export const getCardTitle = (card: {
	selectedContent?: { title: string };
	title: string;
	slogans: string[];
	itemType: string;
}): string => {
	if (!card) {
		return '';
	}

	switch (card.itemType) {
		case 'SLOGAN':
			return (card.slogans as string[])[0];
		case 'TRACKING':
			return card.title;
		default:
			return card.title || card.selectedContent ? card.selectedContent!.title : '' || '';
	}
};

export default class ProgramContents extends React.Component<ProgramViewProps> {
	public static defaultProps = {
		previewItems: [],
		params: {},
	};

	public renderCards(cards: any[]) {
		const selectedContents = cards.map((card) => {
			return {
				...card.selectedContent,
				title: getCardTitle(card),
				type: camelCase(card.itemType),
				fallbackImage: card.fallbackImage,
			};
		});

		return selectedContents.map((card: CardPreviewProps, index: number) => {
			return (
				<div key={index} className="m-program-preview__card">
					<CardPreview {...card} />
				</div>
			);
		});
	}

	public render() {
		const { preview, inactive, previewItems, onStartProgram } = this.props;

		return (
			<div className="m-program-preview">
				<div className="container">
					<div className="row">
						<div className="col-xs-12 col-md-9">
							<div className="m-program-preview__head">
								<h2 className="m-program-preview__title">
									{i18n('react.impulsCoach.components.ProgramContents.previewCards.title')}
								</h2>
								{preview && (
									<div
										className="m-program-preview__text m-program-preview__text--cms"
										dangerouslySetInnerHTML={{
											__html: preview,
										}}
									/>
								)}
								{!preview && (
									<p className="m-program-preview__text">
										{i18n('react.impulsCoach.components.ProgramContents.previewCards.text')}
									</p>
								)}
							</div>
						</div>
					</div>
				</div>
				<div className="container">
					<div className="row">
						<div className="col-xs-12">
							<div className="m-program-preview__cards">{this.renderCards(previewItems)}</div>
						</div>
					</div>
				</div>
				<div className="m-program-preview__back" />
				{!inactive && (
					<div className="m-program-preview__button">
						<Cta
							delegate={onStartProgram}
							text={i18n('react.impulsCoach.components.ProgramContents.startCtaCaption')}
							icon={'play'}
						/>
					</div>
				)}
			</div>
		);
	}
}
